import { Button, Tabs, styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const OpportunitiesCont = styled('div')(({ theme }) => ({
  display: 'flex',
  height: 'calc(100vh - 110px)',
}));
